import React from 'react';

/**
 * Demo / evaluation-mode disclaimer (Phase 17 PRD-02): demo build only
 * (REACT_APP_SHOW_EVAL_BANNER=true in .env.demo). Compared inline so the production bundle drops
 * the banner text entirely. Shown on every screen before sign-in: the sign-in form, the offline
 * lock screen and the install guide (Phase 16A).
 */
const EvalModeBanner: React.FC<{ className?: string }> = ({ className = '' }) => {
  if (process.env.REACT_APP_SHOW_EVAL_BANNER !== 'true') return null;
  return (
    <div className={`mb-6 p-4 bg-amber-50 border-2 border-amber-400 rounded-lg shadow-sm text-left ${className}`} data-testid="eval-banner">
      <div className="flex items-start gap-2 mb-2">
        <svg className="w-6 h-6 text-amber-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
        </svg>
        <div className="flex-1">
          <h3 className="text-sm font-bold text-amber-900 mb-2">⚠️ EVALUATION MODE - DEMO SYSTEM</h3>
          <ul className="text-xs text-amber-900 space-y-1.5 list-disc list-inside">
            <li className="font-semibold">System is in evaluation/demo mode for testing purposes only</li>
            <li className="font-semibold">DO NOT enter any personal, protected health information (PHI), or sensitive data</li>
            <li>HIPAA certification process is currently in progress</li>
            <li>This system is NOT HIPAA-compliant at this time</li>
            <li className="font-semibold">Company assumes NO liability for any damages, data breaches, or unauthorized access</li>
            <li>Use of this demo system is at your own risk</li>
          </ul>
          <p className="text-xs text-amber-900 mt-2 font-medium">
            By proceeding, you acknowledge and accept these terms and conditions.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EvalModeBanner;
